import { Provider } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { CONFIG } from '../tokens/config.token';

export function provideConfig(): Provider {
  return [
    {
      provide: CONFIG,
      useFactory: (configService: ConfigService) => configService.getConfig(),
      deps: [ConfigService],
    },
  ];
}
